import instance from './axiosInstance';

export const getGlobalFeatureFlags = (params, http = instance, options = {}) =>
  http.get('/global_feature_flags/', params, options);
